import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, Field } from 'redux-form'
import {
  renderTextField,
  renderCheckbox,
  renderSelectField,
  renderDatePicker
} from '../auth/form_helpers'
import { Redirect } from 'react-router-dom'
import '../../style/style.css';
import {lightBlack, darkBlack} from 'material-ui/styles/colors';
import RaisedButton from 'material-ui/RaisedButton'
import {List, ListItem} from 'material-ui/List';
import Menu from 'material-ui/Menu';
import Popover, {PopoverAnimationVertical} from 'material-ui/Popover';
import MenuItem from 'material-ui/MenuItem';
import Paper from 'material-ui/Paper';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentClear from 'material-ui/svg-icons/content/clear';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import ActionDelete from 'material-ui/svg-icons/action/delete';

import CommunicationPhone from 'material-ui/svg-icons/communication/phone';

const styles = {
  block: {
    maxWidth: 250,
  },
  checkbox: {
    marginBottom: 16,
  },
  pt15: {
    paddingTop: 15,
  },
  m15: {
    marginTop: 15,
  },
};
var jsonpatch = require('fast-json-patch')

class PersonForm extends Component {

  constructor(props) {
    super(props)

    this.state = {
      forValidQTypes: '',
      validQTypes: [],
      openPopover: false,
      openfee: false,
      opengroup: false,
      activetab: ''
    }
  }

  handlePopoverClick = (event) => {
    // This prevents ghost click.
    event.preventDefault()
    this.setState({
      openPopover: true,
      anchorEl: event.currentTarget,
    })
  }

  handleRequestPopoverClose = () => {
    this.setState({
      openPopover: false,
    });
  }

  componentWillMount() {
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  componentWillUpdate() {
    if (typeof this.props.tracker !== 'undefined') {
      if (typeof this.props.tracker.values !== 'undefined') {
        if (typeof this.props.tracker.values.qualificationsnew !== 'undefined') {
          if (typeof this.props.tracker.values.qualificationsnew.area !== 'undefined') {
            if (this.props.tracker.values.qualificationsnew.area !== this.state.forValidQTypes) {
              this.setState({
                forValidQTypes: this.props.tracker.values.qualificationsnew.area,
              })
            }
          }
        }
      }
    }
  }
  
  componentDidUpdate() {
    if (typeof this.props.tracker !== 'undefined') {
      if (typeof this.props.tracker.values !== 'undefined') {
        if (typeof this.props.tracker.values.qualificationsnew !== 'undefined') {
          if (typeof this.props.tracker.values.qualificationsnew.area !== 'undefined') {
            this.props.qualification.map((option, index) => {
              if (this.state.forValidQTypes !== this.props.tracker.values.qualificationsnew.area) {
                if (option.value === this.props.tracker.values.qualificationsnew.area) {
                  this.setState({
                    validQTypes: option.validTypes,
                  })
                }
              }
            })
          }
        }
      }
    }

    if ( typeof this.props.tracker !== 'undefined' && typeof this.props.tracker.values !== 'undefined' && typeof this.props.tracker.values.psychotherapist !== 'undefined' && this.props.tracker.values.psychotherapist.isPatientgroup && this.props.tracker.values.psychotherapist.isTheory && this.props.tracker.values.psychotherapist.isExam && this.props.tracker.values.psychotherapist.isPsychotherapist !== true)
    {
      this.props.change('psychotherapist.isPsychotherapist', true)
    } else if ( typeof this.props.tracker !== 'undefined' && typeof this.props.tracker.values !== 'undefined' && typeof this.props.tracker.values.psychotherapist !== 'undefined') {
      if (this.props.tracker.values.psychotherapist.isPsychotherapist && (this.props.tracker.values.psychotherapist.isPatientgroup !== true || this.props.tracker.values.psychotherapist.isTheory !== true || this.props.tracker.values.psychotherapist.isExam !== true)) {
        this.props.change('psychotherapist.isPsychotherapist', false)
      }
    }
    if (typeof this.props.track !== 'undefined' && this.state.activetab === '') {
      switch (this.props.track) {
        case 'skgroups':
          this.setState({activetab: 'skgroups'});
          break;
        case 'tgroups':
          this.setState({activetab: 'tgroups'});
          break;
        case 'leadedgroups':
          this.setState({activetab: 'leadedgroups'});
          break;
        default: 
          void(0)
      }
    }
  }

  renderAlert() {
    if (this.props.errorMessage) {
      return <div className="alert alert-danger">
        <strong>Oops: </strong>{this.props.errorMessage}
      </div>
    }
  }

  renderPopover() {
    if (typeof this.props.names !== 'undefined' && this.props.names !== false) {
      return [
        <div key={1}>
          <RaisedButton
            onClick={this.handlePopoverClick}
            label="Személy összes neve"
          />
          <Popover
            open={this.state.openPopover}
            anchorEl={this.state.anchorEl}
            anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
            targetOrigin={{horizontal: 'left', vertical: 'top'}}
            onRequestClose={this.handleRequestPopoverClose}
            animation={PopoverAnimationVertical}
          >
            <Menu>
              {
                this.props.names[0].map((option, index) => {
                  return <MenuItem key={index} primaryText={option} />
                })
              }
            </Menu>
          </Popover>
        </div>
      ]
    }
  }

  delete (text) {
    return () => {
        this.props.change(text, null)
    }
  }

  renderBirthday() {
    if (typeof this.props.personinfos.personal !== 'undefined') {
      if (typeof this.props.personinfos.personal.birthday !== 'undefined') {
        return <div>
          <Field
            className={
              typeof this.props.tracker !== 'undefined' ?
                typeof this.props.tracker.values !== 'undefined' ?
                  typeof this.props.tracker.values.personal !== 'undefined' ?
                    typeof this.props.tracker.values.personal.birthday !== 'undefined' ?
                      this.props.tracker.values.personal.birthday === null ? 'personalBirthday dateInput deleted'
                      : 'personalBirthday dateInput'
                    : 'personalBirthday dateInput'
                  : 'personalBirthday dateInput'
                : 'personalBirthday dateInput'
              : 'personalBirthday dateInput'
            }
            component={renderDatePicker}
            label="születésnap"
            floatingLabelText="született"
            hintText="született"
            type="text"
            style={{width: 120}}
            defaultDate={new Date(this.props.personinfos.personal.birthday)}
            name="personal.birthday"
            ref='refpersonalBirthday dateInput'
          />
          <Field
            component={renderTextField}
            className="dateText"
            floatingLabelText=""
            name="personal.birthday"
            type="text"
          />
        {
          typeof this.props.tracker !== 'undefined' ?
            typeof this.props.tracker.values !== 'undefined' ?
              typeof this.props.tracker.values.personal !== 'undefined' ?
                typeof this.props.tracker.values.personal.birthday !== 'undefined' ?
                  this.props.tracker.values.personal.birthday !== null ? (<div className="">
                      <IconButton onClick={this.delete("personal.birthday")} className="deleteIcon">
                        <ContentClear />
                      </IconButton>
                    </div>)
                  : void(0)
                : void(0)
              : void(0)
            : void(0)
          : void(0)
        }
        </div>
      } else {
        return <div>
          <Field
            className={
              typeof this.props.tracker !== 'undefined' ?
                typeof this.props.tracker.values !== 'undefined' ?
                  typeof this.props.tracker.values.personal !== 'undefined' ?
                    typeof this.props.tracker.values.personal.birthday !== 'undefined' ?
                      this.props.tracker.values.personal.birthday === null ? 'personalBirthday dateInput deleted'
                      : 'personalBirthday dateInput'
                    : 'personalBirthday dateInput'
                  : 'personalBirthday dateInput'
                : 'personalBirthday dateInput'
              : 'personalBirthday dateInput'
            }
            component={renderDatePicker}
            label="születésnap"
            floatingLabelText="született"
            hintText="született"
            type="text"
            style={{width: 120}}
            name="personal.birthday"
          />
          <Field
            component={renderTextField}
            className="dateText"
            floatingLabelText=""
            name="personal.birthday"
            type="text"
          />
          {
            typeof this.props.tracker !== 'undefined' ?
              typeof this.props.tracker.values !== 'undefined' ?
                typeof this.props.tracker.values.personal !== 'undefined' ?
                  typeof this.props.tracker.values.personal.birthday !== 'undefined' ?
                    this.props.tracker.values.personal.birthday !== null ? (<div className="">
                        <IconButton onClick={this.delete("personal.birthday")} className="deleteIcon">
                          <ContentClear />
                        </IconButton>
                      </div>)
                    : void(0)
                  : void(0)
                : void(0)
              : void(0)
            : void(0)
          }
        </div>
      }
    } else {
      return <div>
        <Field
          className={
            typeof this.props.tracker !== 'undefined' ?
              typeof this.props.tracker.values !== 'undefined' ?
                typeof this.props.tracker.values.personal !== 'undefined' ?
                  typeof this.props.tracker.values.personal.birthday !== 'undefined' ?
                    this.props.tracker.values.personal.birthday === null ? 'personalBirthday dateInput deleted'
                    : 'personalBirthday dateInput'
                  : 'personalBirthday dateInput'
                : 'personalBirthday dateInput'
              : 'personalBirthday dateInput'
            : 'personalBirthday dateInput'
          }
          component={renderDatePicker}
          label="születésnap"
          floatingLabelText="született"
          hintText="született"
          type="text"
          style={{width: 120}}
          name="personal.birthday"
        />
          <Field
            component={renderTextField}
            className="dateText"
            floatingLabelText=""
            name="personal.birthday"
            type="text"
          />
        {
          typeof this.props.tracker !== 'undefined' ?
            typeof this.props.tracker.values !== 'undefined' ?
              typeof this.props.tracker.values.personal !== 'undefined' ?
                typeof this.props.tracker.values.personal.birthday !== 'undefined' ?
                  this.props.tracker.values.personal.birthday !== null ? (<div className="">
                      <IconButton onClick={this.delete("personal.birthday")} className="deleteIcon">
                        <ContentClear />
                      </IconButton>
                    </div>)
                  : void(0)
                : void(0)
              : void(0)
            : void(0)
          : void(0)
        }
      </div>
    }
  }

  anonim = ( val ) => {
    if (window.confirm("A személy minden személyes adata törlésre kerül!")) {
      this.props.handleClose();
      this.props.anonimize('/persons.anonymize', '/'+val);
    } else {
      return false;
    }
  }

  renderAnonimizer() {
    if (typeof this.props.personinfos.id !== 'undefined') {
      return <RaisedButton
        onClick={() => { this.anonim(this.props.personinfos.id) }}
        label="anonimizálás"
      />
    }
  }

  fees = ( val ) => {
    this.props.getEnums('/persons', '/'+val+'/fees', 'Fees');
  }

  renderGetfees() {
    if (typeof this.props.personinfos.id !== 'undefined') {
      if (typeof this.props.fees !== 'undefined') {
        // let uu = uuidv4();
        return <div>
          <label>Befizetések:</label>
          {
            this.props.fees.map((option, index) => {
              let reasontext;
              let type;
              if (typeof option.type !== "undefined") {
                let typeHun;
                if (option.type == 'all') {
                  typeHun = 'összes'
                } else if (option.type == 'membership-fee') {
                  typeHun = 'tagdíj'
                  reasontext = 'év'
                } else if (option.type == 'registration-fee') {
                  typeHun = 'regisztrációs díj'
                  reasontext = 'pozíciószámú csoport'
                } else if (option.type == 'group-registration-fee') {
                  typeHun = 'csoport regisztrációs díj'
                  reasontext = 'pozíciószámú csoport'
                } else {
                  typeHun = option.type
                }
                if (option.type.length > 0) {
                  type = <span>
                    <span> </span>
                    <span style={{color: darkBlack}}>Típus:</span>
                    <span> {typeHun} </span>
                  </span>
                }
              }
              let reason;
              if (typeof option.reason !== "undefined") {
                if (option.reason.length > 0) {
                  reason = <span>
                    <span style={{color: darkBlack}}> </span>
                    <span> {option.reason} </span>
                  </span>
                }
              }

              let plusClass;
              if (option.isRemissed !== true && typeof option.debit !== "undefined" && option.debit !== 0) {
                plusClass = 'hasDebit'
              }

              let debit;
              if (typeof option.debit !== "undefined") {
                debit = <span className={plusClass}>
                  <span> </span>
                  <span> Tartozás:</span>
                  <span> {option.debit} Ft</span>
                </span>
              }
              let paymentDate;
              if (typeof option.paymentDate !== "undefined") {
                if (option.paymentDate.length > 0) {
                  paymentDate = <span>
                    <span> </span>
                    <span style={{color: darkBlack}}>Befizetés dátuma:</span>
                    <span> {option.paymentDate} </span>
                  </span>
                }
              }
              let invoiceNumber;
              if (typeof option.invoiceNumber !== "undefined") {
                if (option.invoiceNumber.length > 0) {
                  invoiceNumber = <span>
                    <span> </span>
                    <span style={{color: darkBlack}}>Számla száma:</span>
                    <span> {option.invoiceNumber} </span>
                  </span>
                }
              }
              let noticeCount;
              if (typeof option.noticeCount !== "undefined") {
                if (option.noticeCount.length > 0) {
                  noticeCount = <span>
                    <span> </span>
                    <span style={{color: darkBlack}}>Kiértesítve</span>
                    <span> {option.noticeCount} alkalommal</span>
                  </span>
                }
              }
              let isRemissed;
              if (option.isRemissed == true) {
                isRemissed = <span>
                  <span> </span>
                  <span style={{color: darkBlack}}>ELENGEDVE</span>
                </span>
              }
              return [<ListItem
                key={index}
                primaryText={
                  <span>
                    <a href={"/fees/"+option.editPath} target="_blank">
                      <span style={{color: darkBlack}}>
                        {reason} <small>{reasontext}</small>
                      </span>
                      <small style={{color: lightBlack}}>
                        <span> - </span>
                        {type}
                        {debit}
                        {paymentDate}
                        {invoiceNumber}
                      </small>
                    </a>
                  </span>
                }
              />]
            })
          }
        </div>
      } else {
        return <div>
          <RaisedButton
            onClick={() => { this.fees(this.props.personinfos.id) }}
            label="befizetések"
          />
        </div>
      }
    }
  }

  renderGetaffairs() {
    if (typeof this.props.personinfos.id !== 'undefined') {
      if (typeof this.props.personinfos.affairs !== 'undefined') {
        // let uu = uuidv4();
        return <div>
          <label>TB ügyek:</label>
          {
            this.props.personinfos.affairs.map((option, index) => {
              let subject;
              if (typeof option.subject !== "undefined") {
                if (option.subject.length > 0) {
                  subject = <span>
                    <span style={{color: darkBlack}}> {option.subject} </span>
                  </span>
                }
              }
              let status;
              if (typeof option.status !== "undefined") {
                if (option.status.length > 0) {
                  status = <span>
                    <span> - </span>
                    <span style={{color: darkBlack}}> {option.status} </span>
                  </span>
                }
              }
              return [<ListItem
                  key={index}
                  primaryText={
                    <a href={"/tb/"+this.props.personinfos.id+'/affairs/'+option.id} target="_blank">
                      <span>
                        <span style={{color: darkBlack}}>{this.props.personinfos.personal.name}</span>
                        <small style={{color: lightBlack}}>
                          <span> - </span>
                          {subject}
                          {status}
                        </small>
                      </span>
                    </a>
                  }
                />]
            })
          }
        </div>
      } else {
        return <div>
          <RaisedButton
            onClick={() => { this.fees(this.props.personinfos.id) }}
            label="befizetések"
          />
        </div>
      }
    }
  }

  skgroups = ( val, type ) => {
    this.setState({activetab: 'skgroups'});
    this.props.getEnums('/persons', '/'+val+'/participations/self-knowledge', 'Groups');
  }

  tgroups = ( val, type ) => {
    this.setState({activetab: 'tgroups'});
    this.props.getEnums('/persons', '/'+val+'/participations/training', 'Groups');
  }

  leadedgroups = ( val, type ) => {
    this.setState({activetab: 'leadedgroups'});
    this.props.getEnums('/persons', '/'+val+'/participations/lead', 'Groups');
  }

  renderGetgroups() {
    if (typeof this.props.personinfos.id !== 'undefined') {
      if (typeof this.props.groups !== 'undefined') {
        return <div>
          <div>
            <RaisedButton
              className={this.state.activetab === 'skgroups' ? 'active' : 'passive'}
              onClick={() => { this.skgroups(this.props.personinfos.id) }}
              label="önismereti csoportok"
            />
            <span> </span>
            <RaisedButton
              className={this.state.activetab === 'tgroups' ? 'active' : 'passive'}
              onClick={() => { this.tgroups(this.props.personinfos.id) }}
              label="képzési csoportok"
            />
            <span> </span>
            <RaisedButton
              className={this.state.activetab === 'leadedgroups' ? 'active' : 'passive'}
              onClick={() => { this.leadedgroups(this.props.personinfos.id) }}
              label="vezetett csoportok"
            />
          </div>
          {
            this.props.groups.map((option, index) => {
              let leadOrExam;
              if (typeof option.body !== "undefined") {
                if (option.body.length > 0) {
                  leadOrExam = <span>
                    <span> Vizsga időpontja: {option.body.exam} </span>
                  </span>
                }
              } else {
                leadOrExam = <span style={{color: '#D32F2F'}}> Vezetett csoport: </span>
              }
              let type;
              if (typeof option.head.type !== "undefined") {
                type = <span>
                  <span style={{color: darkBlack}}> Típus: </span>
                  <span style={{color: '#EF6C00'}}> {option.head.type} </span>
                </span>
              }
              let positionNumber;
              if (typeof option.head.positionNumber !== "undefined") {
                positionNumber = <span>
                  <span style={{color: darkBlack}}> Pozíciószám: </span>
                  <span> {option.head.positionNumber} </span>
                </span>
              }
              let leaders;
              if (typeof option.head.leaders !== "undefined") {
                if (option.head.leaders.length > 0) {
                  leaders = <span>
                    <span style={{color: darkBlack}}> Vezetők: </span>
                    {
                      option.head.leaders.map((item, ind) => {
                        return <span key={ind}>{ind === 0 ? '' : ', '}{item}</span>
                      })
                    }
                  </span>
                }
              }
              let startDate;
              if (typeof option.head.startDate !== "undefined") {
                if (option.head.startDate.length > 0) {
                  startDate = <span>
                    <span style={{color: darkBlack}}> Időtartam: </span>
                    <span> {option.head.startDate} - {option.head.endDate} </span>
                  </span>
                }
              }
              let lessonCount;
              if (typeof option.head.lessonCount !== "undefined") {
                if (option.head.lessonCount.length > 0) {
                  lessonCount = <span>
                    <span style={{color: darkBlack}}> Hossz: </span>
                    <span> {option.head.lessonCount} alkalom</span>
                  </span>
                }
              }
              return [<ListItem
                key={index}
                primaryText={
                  <a href={"/"+(option.head.type.indexOf('önismereti') > -1 ? 'self-knowledge-groups' : 'training-groups')+"/"+option.head.id} target="_blank">
                    <span>
                      <span style={{color: darkBlack}}>
                        {positionNumber} 
                      </span>
                      <small style={{color: lightBlack}}>
                        {leadOrExam}
                        {type}
                        {leaders}
                        {startDate}
                        {lessonCount}
                      </small>
                    </span>
                  </a>
                }
              />]
            })
          }
        </div>
      } else {
        return <div>
          <RaisedButton
            onClick={() => { this.skgroups(this.props.personinfos.id) }}
            label="önismereti csoportok"
          />
          <span> </span>
          <RaisedButton
            onClick={() => { this.tgroups(this.props.personinfos.id) }}
            label="képzési csoportok"
          />
          <span> </span>
          <RaisedButton
            onClick={() => { this.leadedgroups(this.props.personinfos.id) }}
            label="vezetett csoportok"
          />
        </div>
      }
    }
  }

  render() {
    if(typeof this.props.personinfos !== 'undefined' && typeof this.props.qualification !== 'undefined' && typeof this.props.qualificationtypes !== 'undefined' && typeof this.props.membership !== 'undefined' && typeof this.props.tracker !== 'undefined' && typeof this.props.tracker.values !== 'undefined') {
      const {handleSubmit} = this.props
      return (
        <div>
            {this.renderAlert()}
            <form onSubmit={handleSubmit} style={styles.pt15} className='formFormat' >
              <div className="full">
                <Field
                  component={renderTextField}
                  floatingLabelText="név"
                  name="personal.name"
                  style={{
                    display: "inline-block",
                    maxWidth: 320
                  }}
                  type="text"/>
              </div>
              <div className='flexContainer' style={{paddingTop: 60}}>
                <Paper zDepth={1}>
                  <label>Személyes adatok:</label>
                  <br />
                  <Field
                    className="hidden"
                    style={{
                      display: 'none'
                    }}
                    component={renderTextField}
                    name="id"
                    type="hidden"
                  />
                  {this.renderBirthday()}
                  <br />
                  <Field
                    component={renderCheckbox}
                    label="meghalt"
                    name="personal.isDead"
                    style={styles.checkbox}
                  />
                  <br />
                  {this.renderPopover()}
                  <br />
                  <hr />
                  <Field
                    component={renderCheckbox}
                    disabled={true}
                    label="Anonim"
                    name="isAnonym"
                    style={styles.checkbox}
                  />
                  {this.renderAnonimizer()}
                </Paper>
                <Paper zDepth={1}>
                  <label>Cím</label>
                  <br />
                  <Field
                    component={renderTextField}
                    floatingLabelText="irányítószám"
                    name="personal.address.zip"
                    type="text"/>
                  <Field
                    component={renderTextField}
                    floatingLabelText="ország"
                    name="personal.address.country"
                    type="text"/>
                  <Field
                    component={renderTextField}
                    floatingLabelText="város"
                    name="personal.address.city"
                    type="text"/>
                  <Field
                    component={renderTextField}
                    floatingLabelText="lakcím"
                    name="personal.address.address"
                    type="text"/>
                  <Field
                    component={renderTextField}
                    floatingLabelText="régi lakcím"
                    name="personal.oldAddress"
                    type="text"/>
                </Paper>
                <Paper zDepth={1}>
                  <label>Elérhetőség:</label>
                  <br />
                  {
                    this.props.personinfos.personal.phone.map((option, index) => {
                      return <div
                        key={index}
                        className="horizontal">
                          <Field
                          className={"itsAWeirdAnInput"}
                          component={renderTextField}
                          floatingLabelText={(index+1)+". telefonszám "}
                          name={"personal.phone.["+index+"].human"}
                          type="text"/>
                        <IconButton
                          iconStyle={styles.smallIcon}
                          style={styles.m15}
                        >
                          <a href={"tel:"+option.machine}>
                            <CommunicationPhone />
                          </a>
                        </IconButton>
                      </div>
                    })
                  }
                  {
                    this.props.personinfos.personal.email.map((option, index) => {
                      return <Field
                        key={index}
                        component={renderTextField}
                        floatingLabelText={(index+1)+". email "}
                        name={"personal.email.["+index+"]"}
                        type="text"/>
                    })
                  }
                  <Field
                    component={renderTextField}
                    floatingLabelText="új telefonszám"
                    name="personal.phoneplus.human"
                    type="text"/>
                  <Field
                    component={renderTextField}
                    floatingLabelText="új email"
                    name="personal.emailplus"
                    type="text"/>
                  <br />
                  <Field
                    component={renderCheckbox}
                    label="publikus elérhetőség"
                    name="personal.isPublicContact"
                    style={styles.checkbox}
                  />
                  <Field
                    component={renderTextField}
                    floatingLabelText="postacím"
                    name="personal.postalAddress"
                    type="text"/>
                </Paper>
                <Paper zDepth={1}>
                  <label>Rendszeradatok:</label>
                  <br />
                  <Field
                    component={renderTextField}
                    floatingLabelText="TB szám"
                    name="system.tbNumber"
                    style={{width: 160}}
                    type="text"/>
                  <Field
                    component={renderTextField}
                    floatingLabelText="index szám"
                    name="system.indexNumber"
                    style={{width: 160}}
                    type="text"/>
                  <br />
                  <Field
                    component={renderCheckbox}
                    label="hírlevelet kér"
                    name="system.isNewsletter"
                    style={styles.checkbox}
                  />
                </Paper>
                <Paper zDepth={1}>
                  <label>Pszichoterapeuta-állapot:</label>
                  <Field
                    component={renderCheckbox}
                    className="forpsychotherapist"
                    label="betegcsoport"
                    name="psychotherapist.isPatientgroup"
                    style={styles.checkbox}
                  />
                  <Field
                    component={renderCheckbox}
                    className="forpsychotherapist"
                    label="elmélet"
                    name="psychotherapist.isTheory"
                    style={styles.checkbox}
                  />
                  <Field
                    component={renderCheckbox}
                    className="forpsychotherapist"
                    label="szakvizsga"
                    name="psychotherapist.isExam"
                    style={styles.checkbox}
                  />
                  <Field
                    component={renderCheckbox} // true, if other 3 true
                    label="pszichoterapeuta"
                    name="psychotherapist.isPsychotherapist"
                    disabled={true}
                    className="psychotherapist"
                    style={styles.checkbox}
                  />
                </Paper>
                <Paper zDepth={1}>
                  <label>Diplomák:</label>
                  <br />
                  {
                    this.props.personinfos.diplomas.map((option, index) => {
                      return <div className="horizontal" key={index}>
                        <Field
                          component={renderTextField}
                          floatingLabelText={(index+1)+". diploma"}
                          name={"diplomas.["+index+"]"}
                          style={{width: 150}}
                          type="text"
                        />
                        <IconButton
                          iconStyle={styles.smallIcon}
                          style={styles.small, styles.m15}
                          onMouseDown={this.delete("diplomas.["+index+"]")}
                        >
                          <ActionDelete />
                        </IconButton>
                      </div>
                    })
                  }
                  <Field
                    component={renderTextField}
                    floatingLabelText="új diploma"
                    name="diplomasplus"
                    style={{width: 150}}
                    type="text"
                  />
                </Paper>
                <Paper zDepth={1}>
                  <label>Tagság történet:</label>
                  <br />
                  {
                    this.props.personinfos.membershipHistory.map((option, index) => {
                      return <div key={index} className="horizontal">
                        <Field
                          className="itsNotAnInput"
                          component={renderSelectField}
                          floatingLabelText={"státusz:"}
                          name={"membershipHistory.["+index+"].status"}
                          style={{width: 150}}
                        >
                          {
                            this.props.membership.map((option, index) => {
                              return <MenuItem key={index} value={option} primaryText={option} />
                            })
                          }
                        </Field>
                        <Field
                          // className="itsNotAnInput"
                          className={
                            typeof this.props.tracker !== 'undefined' ?
                              typeof this.props.tracker.values !== 'undefined' ?
                                typeof this.props.tracker.values.membershipHistory[index] !== 'undefined' ?
                                  this.props.tracker.values.membershipHistory[index].start === null ? 'itsNotAnInput dateInput deleted'
                                  : 'itsNotAnInput dateInput'
                                : 'itsNotAnInput dateInput'
                              : 'itsNotAnInput dateInput'
                            : 'itsNotAnInput dateInput'
                          }
                          component={renderDatePicker}
                          inputStyle={{width: 100}}
                          floatingLabelText={"kezdete:"}
                          name={"membershipHistory.["+index+"].start"}
                          defaultDate={new Date(this.props.tracker.values.membershipHistory[index].start)}
                          type="text"
                          style={{width: 100}}
                        />
                        <Field
                          component={renderTextField}
                          className="dateText"
                          floatingLabelText=""
                          name={"membershipHistory.["+index+"].start"}
                          type="text"
                        />
                        <IconButton
                          iconStyle={styles.smallIcon}
                          style={styles.small, styles.m15}
                          onMouseDown={this.delete("membershipHistory.["+index+"].status")}
                          onMouseUp={this.delete("membershipHistory.["+index+"].start")}
                        >
                          <ActionDelete />
                        </IconButton>
                      </div>
                    })
                  }
                  <div className="horizontal">
                    <Field
                      component={renderSelectField}
                      label="új státusz"
                      name="membershipHistoryNew.status"
                      style={{width: 150}}
                    >
                      {
                        this.props.membership.map((option, index) => {
                          return <MenuItem key={index} value={option} primaryText={option} />
                        })
                      }
                    </Field>
                    <Field
                      className={
                        typeof this.props.tracker !== 'undefined' ?
                          typeof this.props.tracker.values !== 'undefined' ?
                            typeof this.props.tracker.values.membershipHistoryNew !== 'undefined' ?
                              typeof this.props.tracker.values.membershipHistoryNew.start !== 'undefined' ?
                                this.props.tracker.values.membershipHistoryNew.start === null ? 'deleted dateInput'
                                : 'dateInput'
                              : 'dateInput'
                            : 'dateInput'
                          : 'dateInput'
                        : 'dateInput'
                                //: void(0)
                              //: void(0)
                            //: void(0)
                          //: void(0)
                        //: void(0)
                      }
                      component={renderDatePicker}
                      floatingLabelText="kezdete"
                      hintText="kezdete"
                      inputStyle={{width: 100}}
                      name="membershipHistoryNew.start" />
                    <Field
                      component={renderTextField}
                      className="dateText"
                      floatingLabelText=""
                      name="membershipHistoryNew.start"
                      type="text"
                    />
                    {
                      typeof this.props.tracker !== 'undefined' ?
                        typeof this.props.tracker.values !== 'undefined' ?
                          typeof this.props.tracker.values.membershipHistoryNew !== 'undefined' ?
                            typeof this.props.tracker.values.membershipHistoryNew.start !== 'undefined' ?
                              this.props.tracker.values.membershipHistoryNew.start !== null ? (<div className="">
                                  <IconButton onClick={this.delete("membershipHistoryNew.start")} className="deleteIcon">
                                    <ContentClear />
                                  </IconButton>
                                </div>)
                              : void(0)
                            : void(0)
                          : void(0)
                        : void(0)
                      : void(0)
                    }
                  </div>
                </Paper>

                <Paper zDepth={1}>
                  <label>Minősítései:</label>
                  {
                    this.props.personinfos.qualifications.map((option, index) => {
                      //let num = index
                      return [
                        <div key={index} className="horizontal">
                          <Field
                            className="itsNotAnInput"
                            component={renderSelectField}
                            floatingLabelText={"terület:"}
                            name={"qualifications.["+index+"].area"}
                            inputStyle={{width: 170}}
                            style={{width: 170}}
                          >
                            {
                              this.props.qualification.map((option, index) => {
                                return <MenuItem key={index} value={option.value} primaryText={option.value} />
                              })
                            }
                          </Field>
                          <Field
                            className="itsNotAnInput"
                            component={renderSelectField}
                            floatingLabelText={"típus:"}
                            name={"qualifications.["+index+"].type"}
                            inputStyle={{width: 230}}
                            style={{width: 230}}
                          >
                            {
                              this.props.qualificationtypes.map((option, index) => {
                                return <MenuItem key={index} value={option} primaryText={option} />
                              })
                            }
                          </Field>
                          <Field
                            className={
                              typeof this.props.tracker !== 'undefined' ?
                                typeof this.props.tracker.values !== 'undefined' ?
                                  typeof this.props.tracker.values.qualifications[index] !== 'undefined' ?
                                    this.props.tracker.values.qualifications[index].date === null ? 'itsNotAnInput deleted dateInput'
                                    : 'itsNotAnInput dateInput'
                                  : 'itsNotAnInput dateInput'
                                : 'itsNotAnInput dateInput'
                              : 'itsNotAnInput dateInput'
                            }
                            component={renderDatePicker}
                            inputStyle={{width: 100}}
                            floatingLabelText={"kezdete:"}
                            name={"qualifications.["+index+"].date"}
                            defaultDate={new Date(this.props.tracker.values.qualifications[index].date)}
                            type="text"
                            style={{width: 100}}
                          />
                          <Field
                            component={renderTextField}
                            className="dateText"
                            floatingLabelText=""
                            name={"qualifications.["+index+"].date"}
                            type="text"
                          />
                          <IconButton
                            iconStyle={styles.smallIcon}
                            style={styles.small, styles.m15}
                            onMouseDown={this.delete("qualifications.["+index+"].area")}
                            onClick={this.delete("qualifications.["+index+"].type")}
                            onMouseUp={this.delete("qualifications.["+index+"].date")}
                          >
                            <ActionDelete />
                          </IconButton>
                        </div>
                        ]
                    })
                  }
                  <br />
                  <div className="horizontal">
                    <Field
                      component={renderSelectField}
                      floatingLabelText="új terület"
                      name="qualificationsnew.area"
                      inputStyle={{width: 170}}
                      style={{width: 170}}
                    >
                      {
                        this.props.qualification.map((option, index) => {
                          return <MenuItem key={index} value={option.value} primaryText={option.value} />
                        })
                      }
                    </Field>
                    <Field
                      component={renderSelectField}
                      floatingLabelText="típusa"
                      name="qualificationsnew.type"
                      inputStyle={{width: 230}}
                      style={{width: 230}}
                    >
                      {
                        //this.props.qualificationtypes.map((option, index) => {
                        this.state.validQTypes.map((option, index) => {
                          return <MenuItem key={index} value={option} primaryText={option} />
                        })
                      }
                    </Field>
                    <Field
                      className={
                        typeof this.props.tracker !== 'undefined' ?
                          typeof this.props.tracker.values !== 'undefined' ?
                            typeof this.props.tracker.values.qualificationsnew !== 'undefined' ?
                              typeof this.props.tracker.values.qualificationsnew.date !== 'undefined' ?
                                this.props.tracker.values.qualificationsnew.date === null ? 'deleted dateInput'
                                //: void(0)
                                : 'dateInput'
                              //: void(0)
                              : 'dateInput'
                            //: void(0)
                            : 'dateInput'
                          //: void(0)
                          : 'dateInput'
                        //: void(0)
                        : 'dateInput'
                      }
                      component={renderDatePicker}
                      inputStyle={{width: 100}}
                      floatingLabelText={"kezdete:"}
                      name={"qualificationsnew.date"}
                      type="text"
                      style={{width: 100}}
                    />
                    <Field
                      component={renderTextField}
                      className="dateText"
                      floatingLabelText=""
                      name={"qualificationsnew.date"}
                      type="text"
                    />
                    {
                      typeof this.props.tracker !== 'undefined' ?
                        typeof this.props.tracker.values !== 'undefined' ?
                          typeof this.props.tracker.values.qualificationsnew !== 'undefined' ?
                            typeof this.props.tracker.values.qualificationsnew.date !== 'undefined' ?
                              this.props.tracker.values.qualificationsnew.date !== null ? (<div className="">
                                  <IconButton onClick={this.delete("qualificationsnew.date")} className="deleteIcon">
                                    <ContentClear />
                                  </IconButton>
                                </div>)
                              : void(0)
                            : void(0)
                          : void(0)
                        : void(0)
                      : void(0)
                    }
                  </div>
                </Paper>

                <Paper zDepth={1}>
                  <label>Megjegyzések:</label>
                  <br />
                  {
                    this.props.personinfos.comments.map((option, index) => {
                      if (option !== null && option.text !== null) {
                        return <div
                          key={index}
                          className={this.props.tracker.values.comments[index].text === null ? 'hidden horizontal' : 'shw horizontal'}>
                          <Field
                            className='itsAWeirdAnInput'
                            component={renderTextField}
                            floatingLabelText={"megjegyzés ("+option.time.substring(0,10)+")"}
                            name={"comments.["+index+"].text"}
                            multiLine={true}
                            disabled={true}
                            rows={1}
                            rowsMax={4}
                            type="text"
                          />
                          <IconButton
                            iconStyle={styles.smallIcon}
                            style={styles.small}
                            onMouseDown={this.delete("comments.["+index+"].text")}
                          >
                            <ActionDelete />
                          </IconButton>
                        </div>
                      }
                    })
                  }
                  <div className="horizontal">
                    <Field
                      component={renderTextField}
                      floatingLabelText="új megjegyzés"
                      hintText="új megjegyzés"
                      type="text"
                      multiLine={true}
                      rows={1}
                      rowsMax={4}
                      name="commentsnew.text" />
                  </div>
                </Paper>
                <Paper zDepth={1}>
                  <List>
                    { this.renderGetfees() }
                  </List>
                </Paper>
                <Paper zDepth={1} className="fullWidth">
                  <List>
                    { this.renderGetaffairs() }
                  </List>
                </Paper>
              </div>
              <Paper zDepth={1} className="fullWidth">
                <List>
                  { this.renderGetgroups() }
                </List>
              </Paper>
              
              <div style={{display: 'none'}}>
                <Paper  zDepth={1} className='flexEnd p15'>
                  <RaisedButton className="PersonFormSubmitButton" type="submit" label="mentés" primary={true} labelColor={'#FFFFFF'}/>
                </Paper>
              </div>
            </form>
        </div>
      )
    } else{
      return (
        <div>
            {this.renderAlert()}
            <form>
              <div>
              </div>
            </form>
        </div>
      )
    }
  }
}

const validate = values => {
  const errors = {}

  if (typeof values.name === 'undefined' || values.name.trim() === '') {
    errors.password = 'A név nem lehet üres'
  }
  if (!values.password) {
    errors.password = 'Please enter a password'
  }

  if (!values.passwordConfirmation) {
    errors.passwordConfirmation = 'Please confirm your password'
  }

  return errors
}

PersonForm = reduxForm({
  form: 'person',
  validate
})(PersonForm)

// You have to connect() to any reducers that you wish to connect to yourself
PersonForm = connect(
  state => ({
    initialValues: state.person.thisperson, // pull initial values from reducer
    enableReinitialize : true
  })
)(PersonForm)

export default PersonForm


// WEBPACK FOOTER //
// ./src/components/persons/person_form.js